import { render, staticRenderFns } from "./BusinessSubscription.vue?vue&type=template&id=5501c518"
import script from "./BusinessSubscription.vue?vue&type=script&lang=js"
export * from "./BusinessSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports